export const endpoint = {
  admin: {
    CARE_INSTRUCTIONS: '/api/v1/admin/care-instructions',
    CONFIRM_PAYMENTS: '/api/v1/admin/confirm-payments',
    LOOK_BOOKS: '/api/v1/admin/look-books',
    MEDIA: '/api/v1/admin/media',
    MEDIA_CONFIG: '/api/v1/admin/media/config',
    POPUPS: '/api/v1/admin/popups',
    PRODUCT_CATEGORY_OPTIONS: '/api/v1/admin/product-categories/options',
    SETTINGS: '/api/v1/admin/settings',
    STORE_LOCATORS: '/api/v1/admin/store-locators',
  },
  frontend: {
    ADDRESS: {
      COUNTRIES: '/api/v1/address/countries',
      COUNTRIES_DEFAULT: '/api/v1/address/countries/default',
    },
    AUTH: {
      LOGIN: '/api/v1/auth/login',
      LOGOUT: '/api/v1/auth/logout',
      LOST_PASSWORD: '/api/v1/auth/lost-password',
      REGISTER: '/api/v1/auth/register',
      RESET_PASSWORD: '/api/v1/auth/reset-password',
    },
    CART: '/api/v1/cart',
    CHECKOUT: {
      BILLING_ADDRESS: '/api/v1/checkout/billing-address',
      INDEX: '/api/v1/checkout',
      ORDER_RECEIVED: '/api/v1/checkout/order-received',
      PAYMENT: {
        BANK_ACCOUNTS: '/api/v1/checkout/payment/bank-accounts',
        OMISE_PROMPTPAY: '/api/v1/checkout/payment/omise-promptpay',
      },
      PAYMENT_METHODS: '/api/v1/checkout/payment-methods',
      SELECT_PAYMENT_METHOD: '/api/v1/checkout/select-payment-method',
      SHIPPING_ADDRESS: '/api/v1/checkout/shipping-address',
    },
    CONFIRM_PAYMENT: {
      GET_BANK_ACCOUNTS: '/api/v1/confirm-payment/bank-accounts',
      INDEX: '/api/v1/confirm-payment',
    },
    COUPON: '/api/v1/coupon',
    LOOK_BOOKS: '/api/v1/look-books',
    ORDERS: '/api/v1/orders',
    PAGES: 'wp-json/wp/v2/pages',
    POSTS: '/api/v1/posts',
    PRODUCT_CATEGORIES: '/api/v1/product-categories',
    PRODUCTS: '/api/v1/products',
    SEARCH: {
      GET: '/app/plugins/ajax-search-for-woocommerce-premium/includes/Engines/TNTSearchMySQL/Endpoints/search.php',
    },
    SHOP: {
      CONFIG: '/api/v1/shop/config',
      RECENTLY_VIEWED_PRODUCTS: '/api/v1/shop/recently-viewed-products',
    },
    SITE_CONFIGURATION: '/api/v1/site-configuration',
    SPECIAL_PRICE_PRODUCTS: '/api/v1/special-prices',
    STORE_LOCATORS: '/api/v1/store-locators',
    USER: {
      BILLING_ADDRESSES: '/api/v1/user/billing-addresses',
      GET_PROFILE: '/api/v1/user/profile',
      SHIPPiNG_ADDRESSES: '/api/v1/user/shipping-addresses',
    },
    WISHLIST: '/api/v1/wishlist',
  },
}
